/**
 * Utilitários para manipulação de avatares
 */

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

/**
 * Constrói a URL completa do avatar
 * @param avatarPath - Caminho relativo do avatar (ex: /uploads/avatars/avatar-123.png)
 * @returns URL completa do avatar ou null se não houver avatar
 */
export const getAvatarUrl = (avatarPath?: string | null): string | undefined => {
  if (!avatarPath) {
    return undefined;
  }

  // Se já é uma URL completa, retorna como está
  if (avatarPath.startsWith('http://') || avatarPath.startsWith('https://')) {
    return avatarPath;
  }

  // Se é um caminho relativo, constrói a URL completa
  if (avatarPath.startsWith('/')) {
    return `${API_BASE_URL}${avatarPath}`;
  }

  // Se não tem barra inicial, adiciona
  return `${API_BASE_URL}/${avatarPath}`;
};

/**
 * Extrai apenas o nome do arquivo do avatar
 * @param avatarPath - Caminho do avatar
 * @returns Nome do arquivo ou null
 */
export const getAvatarFilename = (avatarPath?: string | null): string | null => {
  if (!avatarPath) {
    return null;
  }

  const parts = avatarPath.split('/');
  return parts[parts.length - 1];
};